export{a as setAssetPath}from"./index-b72adede.js";export{a as addIcons}from"./utils-2c56d1c8.js";